import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MobileModalModule } from '@app/core/components/mobile-modal/mobile-modal.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { StepByStepWizardModule } from '@app/shared/step-by-step-wizard';
import { SharedModule } from '@app/vocabulary/shared.module';

import { SpinnersModule } from '../../../core/components/spinners/spinners.module';
import { IconComponent } from '../../icon/icon.component';
import { AddCardHeaderDetailsComponent } from '../components/add-card-header-details/add-card-header-details.component';
import { MeetingFooterDetailsComponent } from '../components/meeting-footer-details/meeting-footer-details.component';
import { PayButtonComponent } from '../components/pay-button/pay-button.component';
import { PaymentOrderComponent } from '../components/payment-order/payment-order.component';
import { PaymentWidgetModule } from '../components/payment-widget';
import { PaymentWidgetMerchantProcessingModule } from '../components/payment-widget/payment-widget-merchant-processing/payment-widget-merchant-processing.module';
import { SchoolHeaderDetailsComponent } from '../components/school-header-details/school-header-details.component';
import { TeacherHeaderDetailsModule } from '../components/teacher-header-details';
import { UserServiceFooterDetailsComponent } from '../components/user-service-footer-details/user-service-footer-details.component';
import { WarningOwnMeetingComponent } from '../components/warning-own-meeting/warning-own-meeting.component';
import { WarningOwnServiceComponent } from '../components/warning-own-service/warning-own-service.component';
import { AddCardWizardDialogComponent } from './add-card-wizard-dialog.component';

@NgModule({
  declarations: [AddCardWizardDialogComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,

    SharedModule,
    StepByStepWizardModule,
    SchoolHeaderDetailsComponent,
    TeacherHeaderDetailsModule,
    MobileModalModule,
    PaymentWidgetModule,
    WarningOwnMeetingComponent,
    WarningOwnServiceComponent,
    UserServiceFooterDetailsComponent,
    MeetingFooterDetailsComponent,
    PayButtonComponent,
    PaymentOrderComponent,
    PaymentWidgetMerchantProcessingModule,
    IconComponent,
    AddCardHeaderDetailsComponent,
    SpinnersModule,
  ],
  exports: [AddCardWizardDialogComponent],
})
export class AddCardWizardDialogModule {}
